const data=[
{
    id:1,
    img:"https://img.freepik.com/free-photo/planner-calendar-schedule-date-concept_53876-121073.jpg?t=st=1719243696~exp=1719247296~hmac=866a58dbc30eae7ec997866bb1096f21560e5f4d822b06131f83ae1bd25438fd&w=740",
    head:" Lorem ipsum dolor",
    body:" Lorem ipsum dolor sit amet consectetur adipisicing elit. Ea neque aliquid hic optio repellendus quibusdam praesentium! Cumque minima, quas eum eos magnam corrupti facilis omnis lorem ipsum.",
    autor:"James Robert"
},
{
    id:2,
    img:"https://img.freepik.com/premium-photo/asian-young-woman-live-streaming-sale-fashion-clothing-is-blogger-presenting-social-people-her-is-influencer-social-online_74952-971.jpg?w=740",
    head:" Lorem ipsum dolor",
    body:" Lorem ipsum dolor sit amet consectetur adipisicing elit. Ea neque aliquid hic optio repellendus quibusdam praesentium! Cumque minima, quas eum eos magnam corrupti facilis omnis lorem ipsum.",
    autor:"Sofia Ali"
},
{
    id:3,
    img:"https://img.freepik.com/free-photo/view-from-hands-pretty-woman-sitting-table-black-shirt-working-laptop-co-working-office-stationery-hands-typing-drinking-coffee-freelance_285396-84.jpg?t=st=1719243845~exp=1719247445~hmac=6135911510e0d1f575e8f33972de5600e64cb4b3d691bea3312c6d283b6aa1aa&w=740",
    head:" Lorem ipsum dolor",
    body:" Lorem ipsum dolor sit amet consectetur adipisicing elit. Ea neque aliquid hic optio repellendus quibusdam praesentium! Cumque minima, quas eum eos magnam corrupti facilis omnis lorem ipsum.",
    autor:"Jamie Dornan"
},
{
    id:4,
    img:"https://img.freepik.com/free-photo/black-friday-elements-assortment_23-2149074075.jpg?t=st=1719243933~exp=1719247533~hmac=7529d1301339ede737e89d2337f7ed08368ce19585892c0183927d1fd0a000c6&w=740",
    head:" Lorem ipsum dolor",
    body:" Lorem ipsum dolor sit amet consectetur adipisicing elit. Ea neque aliquid hic optio repellendus quibusdam praesentium! Cumque minima, quas eum eos magnam corrupti facilis omnis lorem ipsum.",
    autor:"Dakota Johnson"
},
{
    id:5,
    img:"https://img.freepik.com/free-photo/young-beautiful-woman-holding-shopping-bags_285396-1217.jpg?t=st=1719244332~exp=1719247932~hmac=80de6919f49ebcc752b76c46aa9a09fa611f3e12c2f9540fe3b5c8cc8fb1487d&w=740",
    head:" Lorem ipsum dolor",
    body:" Lorem ipsum dolor sit amet consectetur adipisicing elit. Ea neque aliquid hic optio repellendus quibusdam praesentium! Cumque minima, quas eum eos magnam corrupti facilis omnis lorem ipsum.",
    autor:"Vivek Suid"
},
{
    id:6,
    img:"https://img.freepik.com/premium-photo/mockup-blank-craft-package-colorful-paper-shopping-bag-with-handles_35380-2733.jpg?w=740",
    head:" Lorem ipsum dolor",
    body:" Lorem ipsum dolor sit amet consectetur adipisicing elit. Ea neque aliquid hic optio repellendus quibusdam praesentium! Cumque minima, quas eum eos magnam corrupti facilis omnis lorem ipsum.",
    autor:"Manish Malhotra"
},
]
export default data